var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isTimeZoneSensitive && _vm.currentTimeZone)?_c('div',{staticClass:"current-timezone",attrs:{"id":"current-timezone"}},[_vm._v("\n  Viewing Data in "),_c('b',[_vm._v(_vm._s(_vm.currentTimeZone))]),_vm._v(" Time Zone\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }